export enum INSURANCE_VISIBILITY {
  MANDATORY = 'S',
  NOT_MANDATORY = 'N',
}

export enum INSURANCE_CATEGORY_VISIBILITY {
  MANDATORY = 'S',
  NOT_VISIBLE = 'I',
  VISIBLE = 'N',
}
